import React from "react";

const LeftSwitcher = ({
    menuItems = [],
    activeItem,
    listRef,
    itemsRef,
    isScrolling,
    hasOverflow,
    thumbTop,
    thumbHeight,
    onThumbMouseDown,
    handleScrollbarMouseEnter,
    handleScrollbarMouseLeave,
    handleMouseEnter,
    Item,
    submenuStyles,
    isHoveringScrollbar,
    triangleTop,
}) => {
    const label = menuItems[0]?.label;

    return (
        <div className={submenuStyles.submenuMega__left}>
            <p className={submenuStyles.submenuMega__label}>{label}</p>
            <div className={submenuStyles.submenuMega__wrapper}>
                <ul
                    role="presentation"
                    className={`${submenuStyles.submenuMega__switcher} ${isScrolling ? submenuStyles.scrolling : ""}`}
                    ref={listRef}
                    onMouseEnter={handleScrollbarMouseEnter}
                    onMouseLeave={handleScrollbarMouseLeave}
                >
                    {menuItems.map((item, index) => (
                        <li
                            key={`${item?.id ?? "item"}-${index}`}
                            ref={(el) => {
                                const list = itemsRef.current;
                                list[index] = el;
                            }}
                        >
                            {item.link ? (
                                <a
                                    href={item.link?.url}
                                    className={submenuStyles.contentColumn__link}
                                    target={item.link?.url?.newTab ? "_blank" : "_self"}
                                    rel="noreferrer"
                                >
                                    <Item
                                        item={item}
                                        index={index}
                                        isActive={activeItem === index}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                    />
                                </a>
                            ) : (
                                <Item
                                    item={item}
                                    index={index}
                                    isActive={activeItem === index}
                                    onMouseEnter={() => handleMouseEnter(index)}
                                />
                            )}
                        </li>
                    ))}
                </ul>

                {hasOverflow && (
                    <div
                        role="presentation"
                        className={`${submenuStyles.submenuMega__scrollTrack} ${
                            isHoveringScrollbar ? submenuStyles.hovering : ""
                        }`}
                        onMouseEnter={handleScrollbarMouseEnter}
                        onMouseLeave={handleScrollbarMouseLeave}
                    >
                        <div
                            role="button"
                            aria-label="Scroll thumb"
                            tabIndex={0}
                            className={`${submenuStyles.submenuMega__scrollThumb} ${
                                isScrolling ? submenuStyles.visible : ""
                            }`}
                            style={{top: `${thumbTop}px`, height: `${thumbHeight}px`}}
                            onMouseDown={onThumbMouseDown}
                        />
                    </div>
                )}

                <div className={submenuStyles.triangleIndicator} style={{top: `${triangleTop}px`}} />
            </div>
        </div>
    );
};

export default LeftSwitcher;
